export const sentryCommentsViewSample = {
  'action': 'created',
  'data': {
    'comment': 'adding a comment',
    'project_slug': 'sentry',
    'comment_id': 1234,
    'issue_id': 100,
    'timestamp': '2022-03-02T21:51:44.118160Z'
  },
  'installation': { 'uuid': 'eac5a0ae-60ec-418f-9318-46dc5e7e52ec' },
  'actor': { 'type': 'user', 'id': 1, 'name': 'colleen' }
}
;

  export const sentryCommentsSample = {
    'action': 'created',
    'data.comment': 'adding a comment',
    'data.issue_id': 100,
    'data.timestamp': '2022-03-02T21:51:44.118160Z',
    'actor.name': 'colleen',
  };
  


// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/sentry_comments.ts